import { useSuspenseQuery } from '@tanstack/react-query';
import { queryKey } from '../../../../../constant/queryKey';
import { marketService } from 'shared/src/api';

export const useMarketRankingTypes = () => {
  return useSuspenseQuery({
    queryKey: queryKey.marketRankingTypes(),
    queryFn: () => marketService.getMarketRankingTypes(),
  });
};
